import React from 'react';
import { FeedbackProps } from '../../../../types';
import { Trans } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { formatDateShort } from '../../../../../../../../utils/dateUtils';

export const EndedReview: React.FC<
  React.PropsWithChildren<{ feedback: FeedbackProps }>
> = ({ feedback }) => {
  return (
    <Row className="align-items-center">
      {feedback.feedbackCycle.flair__Signature_required__c &&
        !feedback.outcome.flair__Accepted_At__c &&
        feedback.outcome.flair__Ended_At__c && (
          <Col xl={8}>
            <Trans
              i18nKey="employeePage.performanceReview.nextPerformanceReview.signedDescription"
              values={{
                acceptedTime: formatDateShort(
                  feedback.outcome.flair__Ended_At__c,
                ),
              }}
              components={[<strong />]}
            />
          </Col>
        )}
    </Row>
  );
};
